import { useMemo } from 'react';
import StudentCard from '../StudentCard';
import PaymentTab from './PaymentTab';
import { RecordTab } from './RecordTab/RecordTab';
import TeachingTab from './TeachingTab/TeachingTab';
import TrainingTab from './TrainingTab/TrainingTab';

export const useTabs = (studentId: string) => {
	const tabs = useMemo(
		() => [
			{
				key: '1',
				label: 'Údaje',
				children: <StudentCard id={studentId} />,
			},
			{
				key: '2',
				label: 'Výuka',
				children: <TeachingTab studentId={studentId} />,
			},
			{
				key: '3',
				label: 'Výcvik',
				children: <TrainingTab studentId={studentId} />,
			},
			{
				key: '4',
				label: 'Platba',
				children: <PaymentTab studentId={studentId} />,
			},
			{
				key: '5',
				label: 'Evidence',
				children: <RecordTab studentId={studentId} />,
			},
		],
		[studentId],
	);

	return tabs; // .filter(tab => !tab.hide);
};
